import { Box, Card, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import PackageItem from '../common/PackageItem.tsx';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { IPackage } from '../../interfaces/studio.ts';

interface ITeammates {
	company_title: string;
	id: number;
	image: string;
	price: string;
	title: string;
}

interface ICombined extends IPackage {
	teammates: ITeammates[]; // An array of ITeammates
}

export default function SimilarDetail() {
	const { t } = useTranslation();

	const { id } = useParams();

	const [data, setData] = useState<ICombined>();

	useEffect(() => {
		axios({
			method: 'get',
			url: `studio/showPackage/${id}`,
		}).then(r => {
			if (r?.data?.success) {
				setData(r?.data?.data);
			}
		});
	}, [id]);

	return (
		<Card className={'w-full px-6 pb-8 pt-4'}>
			<Box className={'mb-6 flex justify-between'}>
				<Typography className={'text-2xl font-medium'}>{t('post_slide_instagram')}</Typography>
			</Box>
			<Grid container spacing={2}>
				{data?.teammates?.map(i => (
					<Grid key={i?.id} sm={6} md={4}>
						<PackageItem title={i?.title ?? ''} price={+(i?.price ?? 0)} link={`/studio/detail/${i?.id}`} image={i?.image} />
					</Grid>
				))}
			</Grid>
		</Card>
	);
}
